import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { StatusOperacional } from "../models/status-operacional.model";

@Injectable()
export class StatusOperacionalService extends BaseService<StatusOperacional>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/status-operacionais';
  }

}